import { useCallback, ChangeEvent } from 'react'
import { useDispatch } from 'react-redux'
import EditorField from 'builder/components/EditorField'
import { TextField } from 'builder/components/TextField'
import { useI18n } from 'builder/hooks/useI18n'
import { useTypedSelector } from 'builder/hooks/useTypedSelector'
import { actions } from 'builder/modules/resumeEditor'

export const Dependants = () => {
  const { i18n } = useI18n()
  const { updateSimpleField } = actions
  const numberOfDependents = useTypedSelector(
    state => state.resumeEditor.resume?.numberOfDependents,
  )
  const dispatch = useDispatch()

  const handleChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      dispatch(
        updateSimpleField({
          name: 'numberOfDependents',
          value: parseInt(event.target.value) || null,
        }),
      )
    },
    [updateSimpleField, dispatch],
  )

  return (
    <>
      <EditorField>
        <TextField
          label={i18n.t('builder.resume_editor.professional_summary.dependants')}
          name="numberOfDependents"
          type="number"
          value={numberOfDependents || ''}
          onChange={handleChange}
          min={0}
        />
      </EditorField>
    </>
  )
}
